'use strict';

var callDateGet = require('../../common/internal/callDateGet');

function getMonth(d) {
  return callDateGet(d, 'Month');
}

module.exports = getMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/getMonth.js
// module id = 35
// module chunks = 0